export default __webpack_public_path__ + "static/media/img_step_lucia03-11.15018e99.jpg";